module.exports = __webpack_public_path__ + "img/6.d9fe5157.jpg";